module.exports = __webpack_public_path__ + "media/images/home/money@2x-a5104a05326834e9ddbce5248887a4ce.png";